export default {
  selectViewedAssets: (state) => state.viewedAssets,
};
